import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';
import mailSetings from '@/settings/mail';

export const GetMailList = (params) => {
  params = fillDefaultParams(params);

  const requestOptions = {
    method: 'GET',
    url: urls.mail_items,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => console.log('mail list get err', e)); // TEMP: to do: if 419 update token and make new req
}

export const SendMailAction = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.mail_items}/${data.id}/${data.action}`,
    params: {
      enabled: data.enabled,
      ...data.options
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => console.log('mail action err', e));
}

export const SendGroupMailAction = (params) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.mail_items}/${params.action}`,
    data: params.toSend
    // params: params.toSend,
    // paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => console.log('mail action err', e));
}

const fillDefaultParams = (params) => {
  Object.keys(mailSetings.defaultParams).forEach(key => {
    if (!params[key])
      params[key] = mailSetings.defaultParams[key];
  });

  return params;
}

// Admin mail
export const GetAdminMail = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.mail_items,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAdminMailItem = (mail_number) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.mail_item}?mail_number=${mail_number}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const PerformAdminAction = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.mail_items}/${data.id}/${data.action}`,
    data: data.params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const PerformAdminGroupAction = (data) => {
  const { ids, action, account_id, signature_uri , enabled , trash_now } = data;

  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.mail_items}/${data.action}`,
    data: {
      ids,
      ...(action === 'sign' && { account_id, signature_uri }),
      ...(action === 'junk' && { enabled , trash_now}),
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAdminGroupMail = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.group_mail_items,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAdminGroupMailItem = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.group_mail_items}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const ChangeAdminGroupMail = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.group_mail_items}/${data.id}`,
    params: {
      group_mail: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };
  
  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteAdminGroupMail = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.group_mail_items}/${id}`
  };
  
  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateAdminGroupMail = (params) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.group_mail_items,
    params: {
      group_mail: params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };
  
  return axios(requestOptions)
    .then(res => res.data);
}

export const FindPrivateMailboxes = (pattern, group_mail_enabled) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.mail_boxes}/${pattern}${group_mail_enabled ? '?group_mail_enabled=true' : ''}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetFreePMBs = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.available_pmbs
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateNewMailItem = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.mail_items,
    data,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const EditMailItem = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.mail_items}/${data.id}`,
    data: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteMailItem = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.mail_items}/${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateBulkMailItems = (items) => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.bulk_mail}`,
    data: {
      mail_items: items
    }
    // params: {
    //   mail_items: items
    // },
    // paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const PublishBulkMail = (data) => {
  const requestOptions = {
    method: 'POST',
    data,
    url: `${urls.admin.publish_bulk_mail}`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveBulkMail = (data) => {
  const requestOptions = {
    method: 'DELETE',
    data,
    url: `${urls.admin.remove_bulk_mail}`,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetForwardingAddress = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.mail_items}/${data.id}/forward_address`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetGroupForwardingAddress = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.group_mail_items}/${data.id}`,
    params: {
      group_mail: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetMailTemplates = (pmb) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.accounts}/${pmb}/mail_items`
  }

  return axios(requestOptions)
    .then(res => res.data);
}